"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergePackageModels = exports.mapPackageToModel = exports.mapPackagesToModel = exports.checkPluginlessUploads = exports.checkAsperaTransfers = exports.checkAsperaFileTransfers = void 0;
var moment_1 = __importDefault(require("moment"));
/* Blast Imports */
var models_1 = require("@app/_state/models");
var log_1 = __importDefault(require("@app/shared/log"));
var api_1 = require("@server/types/api");
// Check the transfer statuses of each file that has an active Aspera transfer
var checkAsperaFileTransfers = function (asperaTransfers, packageId, files) {
    if (!Array.isArray(files)) {
        files = [files];
    }
    if (asperaTransfers.toArray().length > 0) {
        var _loop_1 = function (f) {
            if (asperaTransfers.has(packageId)) {
                var fileTransfers = asperaTransfers.get(packageId).valueSeq().toArray().filter(function (t) { return (!t.isFullPackage && t.transferTitle === f.basename); }).sort(function (a, b) { return moment_1.default(b.modifyDate).diff(a.modifyDate); });
                log_1.default.debug(f.basename + " has " + fileTransfers.length + " transfers");
                if (fileTransfers.length > 0) {
                    var transferState = ((fileTransfers[0].direction === api_1.Direction.RECEIVE) && !(fileTransfers[0].isFullPackage)) ? fileTransfers[0].packageState.toString() : undefined;
                    f.transferInfo = {
                        transferredBytes: fileTransfers[0].transferredBytes,
                        transferId: (transferState) ? fileTransfers[0].transferId : undefined,
                        transferState: transferState
                    };
                    if (transferState === models_1.PackageTransferState.FAILED) {
                        f.errorCode = fileTransfers[0].errorCode;
                        f.errorDesc = fileTransfers[0].errorDesc;
                        f.errorMsg = 'Error downloading the file';
                    }
                }
            }
        };
        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var f = files_1[_i];
            _loop_1(f);
        }
    }
    return files;
};
exports.checkAsperaFileTransfers = checkAsperaFileTransfers;
// Check the transfer statuses of each package that has an active Aspera transfer
var checkAsperaTransfers = function (asperaTransfers, packages, type) {
    if (!Array.isArray(packages)) {
        packages = [packages];
    }
    if (asperaTransfers.toArray().length > 0) {
        for (var _i = 0, packages_1 = packages; _i < packages_1.length; _i++) {
            var p = packages_1[_i];
            if (asperaTransfers.has(p.id)) {
                var packageTransfers = void 0;
                if (type === models_1.PackageView.SENT) {
                    packageTransfers = asperaTransfers.get(p.id).valueSeq().toArray().filter(function (t) { return t.direction === api_1.Direction.SEND; }).sort(function (a, b) { return moment_1.default(b.modifyDate).diff(a.modifyDate); });
                }
                else {
                    packageTransfers = asperaTransfers.get(p.id).valueSeq().toArray().filter(function (t) { return t.isFullPackage; }).sort(function (a, b) { return moment_1.default(b.modifyDate).diff(a.modifyDate); });
                }
                if (packageTransfers.length > 0) {
                    var transferState = void 0;
                    var isTransferComplete = packageTransfers[0].packageState === models_1.PackageTransferState.COMPLETE;
                    var isTransferRemoved = packageTransfers[0].packageState === models_1.PackageTransferState.REMOVED;
                    if (type === models_1.PackageView.RECEIVED || type === models_1.PackageView.INBOX) {
                        transferState = (packageTransfers[0].direction === api_1.Direction.RECEIVE && packageTransfers[0].isFullPackage) ?
                            (isTransferComplete || isTransferRemoved) ? undefined : packageTransfers[0].packageState :
                            undefined;
                    }
                    else if (type === models_1.PackageView.SENT) {
                        transferState = packageTransfers[0].direction === api_1.Direction.SEND ? packageTransfers[0].packageState.toString() : undefined;
                    }
                    else {
                        transferState = ((packageTransfers[0].direction === api_1.Direction.RECEIVE) && (packageTransfers[0].isFullPackage)) ? packageTransfers[0].packageState.toString() : undefined;
                    }
                    if (p.state !== models_1.PackageState.DELETED && p.state !== models_1.PackageState.EXPIRED) {
                        p.transferInfo = {
                            transferredBytes: packageTransfers[0].transferredBytes,
                            transferId: ((isTransferComplete || isTransferRemoved)
                                && (type === models_1.PackageView.RECEIVED || type === models_1.PackageView.INBOX)) ? '' : packageTransfers[0].transferId,
                            transferState: transferState
                        };
                        if (transferState === models_1.PackageTransferState.FAILED) {
                            p.errorCode = packageTransfers[0].errorCode;
                            p.errorDesc = packageTransfers[0].errorDesc;
                            p.errorMsg = 'Error downloading the package';
                        }
                    }
                }
            }
        }
    }
    return packages;
};
exports.checkAsperaTransfers = checkAsperaTransfers;
// Check the transfer statuses of each package being uploaded w/o the Aspera plugin
var checkPluginlessUploads = function (pluginlessUploads, packages) {
    for (var _i = 0, packages_2 = packages; _i < packages_2.length; _i++) {
        var p = packages_2[_i];
        if (pluginlessUploads.has(p.id)) {
            var upload = pluginlessUploads.get(p.id);
            if (p.state !== models_1.PackageState.DELETED && p.state !== models_1.PackageState.EXPIRED) {
                p.transferInfo = {
                    transferredBytes: upload.transferredBytes || 0,
                    transferId: '',
                    transferState: upload.state || undefined
                };
            }
        }
    }
    return packages;
};
exports.checkPluginlessUploads = checkPluginlessUploads;
// Convert multiple back-end packages
var mapPackagesToModel = function (packages) {
    return packages.map(function (p) { return exports.mapPackageToModel(p); });
};
exports.mapPackagesToModel = mapPackagesToModel;
// Convert back-end package into a front-end package
var mapPackageToModel = function (pkg) {
    var disableForwarding = false;
    var encrypted = false;
    if (pkg.metadata) {
        pkg.metadata.filter(function (m) {
            if (m.name === 'ForwardDisabled') {
                disableForwarding = m.value === 'yes'; // m.value === 'yes' ? true : false
            }
            if (m.name === 'PasswordProtected') {
                encrypted = m.value === 'yes'; // m.value === 'yes' ? true : false
            }
        });
    }
    console.log('MAPPING PACKAGE', pkg); // eslint-disable-line no-console
    return {
        id: pkg.id,
        creationDate: pkg.creationDate || moment_1.default().format(),
        errorCode: pkg.errorCode,
        errorDesc: pkg.errorDesc,
        errorMsg: pkg.errorMsg,
        expirationDate: pkg.state === models_1.PackageState.DELETED ?
            moment_1.default().add(-1, 'days').format() :
            pkg.expirationDate || moment_1.default().add(1, 'hours').format(),
        sender: pkg.sender.user,
        title: pkg.title,
        totalBytes: pkg.totalBytes,
        transferredBytes: pkg.transferInfo ? pkg.transferInfo.transferredBytes || 0 : 0,
        downloaders: (pkg.downloaders) ? pkg.downloaders : [],
        note: pkg.note,
        archived: pkg.archived,
        recipients: pkg.recipients.map(function (r) { return r.user; }),
        pkgState: pkg.state,
        disableForwarding: disableForwarding,
        encrypted: encrypted,
        state: pkg.transferInfo ? pkg.transferInfo.transferState : undefined,
        packageTransferId: pkg.transferInfo ? pkg.transferInfo.transferId : undefined
    };
};
exports.mapPackageToModel = mapPackageToModel;
// Merge two front-end packages into one
var mergePackageModels = function (pkg1, pkg2) {
    var mergedPackage = pkg1;
    if (!pkg2) {
        return pkg1;
    }
    if (pkg1.id === pkg2.id) {
        if (mergedPackage.packageTransferId === undefined) {
            mergedPackage.packageTransferId = pkg2.packageTransferId;
        }
        if (mergedPackage.state === undefined) {
            mergedPackage.state = pkg2.state;
        }
        return mergedPackage;
    }
    else {
        log_1.default.debug("Cannot merge packages (" + pkg1.id + " & " + (pkg2 ? pkg2.id : '??') + "; returning package " + pkg1.id);
        return pkg1;
    }
};
exports.mergePackageModels = mergePackageModels;
